import { Button, Form, Input, Modal, Popconfirm, Space, Table, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ASIDeviceService } from "../../../ducks/asi-devices/asi-devices";

interface DataType {
  _id: string;
  deviceId: string;
  description: string;
  comment?: string;
  ip: string;
  port: number;
  login: string;
  password: string;
  hubId: string;
  hubExternalId: string;
  spaceId: string;
  zoneIds: string[];
  heartbeat: number;
  createdAt: string;
  __v: 0;
}

interface IBindASIWithHub {
  asiDevices: ASIDeviceService;
}

const deps: IBindASIWithHub = {
  asiDevices: new ASIDeviceService(),
};

const DeleteCameraComponent = (payload: any) => {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const showPopconfirm = () => {
    setOpen(true);
  };

  const handleOk = async () => {
    setConfirmLoading(true);

    try {
      await deps.asiDevices.delete(payload.asiId as string);

      setOpen(false);
      setConfirmLoading(false);
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    setConfirmLoading(false);
    setOpen(false);
  };

  return (
    <Popconfirm
      title="Удаление"
      description="Вы действительно хотите удалить ASI ?"
      open={open}
      onConfirm={handleOk}
      okButtonProps={{ loading: confirmLoading, danger: true }}
      onCancel={handleCancel}
      cancelText={"Отменить"}
      okText={"Удалить"}
    >
      <Button danger onClick={showPopconfirm}>
        Удалить
      </Button>
    </Popconfirm>
  );
};

interface IASIListProps {
  hubId: string | undefined;
}

const ASIDeviceList = (props: IASIListProps) => {
  const [asiList, setASIList] = useState<DataType[]>([]);
  const [editOpen, setEditOpen] = useState(false);
  const [editing, setEditing] = useState<DataType | null>(null);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();
  const asiService = new ASIDeviceService();

  const getASIList = async () => {
    try {
      const response = await asiService.getList(props.hubId as string);
      setASIList(response || []);
    } catch (error) {
      setASIList([]);
    }
  };

  useEffect(() => {
    getASIList();
  }, []);

  const openEdit = (asi: DataType) => {
    setEditing(asi);
    form.setFieldsValue({
      description: asi.description,
      comment: asi.comment || "",
    });
    setEditOpen(true);
  };

  const saveEdit = async () => {
    if (!editing) return;
    setSaving(true);
    try {
      const values = await form.validateFields();
      await asiService.updateMeta(editing._id, values);
      message.success("Сохранено");
      setEditOpen(false);
      getASIList();
    } catch (e) {
      console.log(e);
      message.error("Не удалось сохранить");
    } finally {
      setSaving(false);
    }
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Комментарий",
      dataIndex: "comment",
      key: "comment",
      render: (v) => v || "—",
    },
    {
      title: "IP",
      dataIndex: "ip",
      key: "ip",
      render: (_, cam) => String(cam.ip + ":" + cam.port),
    },
    {
      title: "Действия",
      key: "action",
      render: (_, asi) => (
        <Space size="middle">
          <Link to={`/devices/${asi._id}`}>Пользователи и зоны</Link>
          <Button type="link" onClick={() => openEdit(asi)}>
            Редактировать
          </Button>
          <DeleteCameraComponent asiId={asi._id} hubId={asi.hubId} />
        </Space>
      ),
    },
  ];

  return (
    <div>
      {!!asiList.length && (
        <Table
          size="small"
          columns={columns}
          dataSource={asiList}
          rowKey={(i) => i._id || i.ip}
        />
      )}
      <Modal
        title="Редактирование ASI"
        open={editOpen}
        onOk={saveEdit}
        onCancel={() => setEditOpen(false)}
        confirmLoading={saving}
        okText="Сохранить"
        cancelText="Отмена"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="description"
            label="Название / описание"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="comment" label="Комментарий">
            <Input.TextArea rows={3} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ASIDeviceList;
